import type { SVGProps } from 'react';
const SvgSettingsCell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_cell_svg__a)">
      <path
        fill="currentColor"
        d="M7 24h2v-2H7v2Zm4 0h2v-2h-2v2Zm4 0h2v-2h-2v2ZM16 .01 8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99ZM16 16H8V4h8v12Z"
      />
    </g>
    <defs>
      <clipPath id="settings_cell_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsCell;
